import React from "react";
import { useParams, Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { COLLECTIONS, CATEGORY_LABEL, byCategory, heroStyles, PRODUCTS } from "@/data/products";
import { ProductCard } from "@/components/ProductCard";

const Banner = ({ cfg }) => (
  <section data-testid="collection-banner" className="relative bg-navy overflow-hidden">
    <div className="absolute inset-0 opacity-[0.07]" style={{ backgroundImage: "radial-gradient(circle at 1px 1px, #fff 1px, transparent 0)", backgroundSize: "22px 22px" }} />
    <div className="relative max-w-7xl mx-auto px-4 sm:px-8 lg:px-12 py-16 lg:py-24">
      <p className="font-mono text-[11px] uppercase tracking-[0.24em] text-denim-accent">{cfg.eyebrow}</p>
      <h1 className="mt-3 font-display text-4xl sm:text-5xl lg:text-6xl font-bold uppercase tracking-tight text-white leading-[0.92]">{cfg.title}</h1>
      <p className="mt-3 text-white/60 text-sm max-w-xl">{cfg.sub || cfg.blurb}</p>
    </div>
  </section>
);

const Grid = ({ products }) => (
  <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 sm:gap-6 lg:gap-7">
    {products.map((p, i) => <ProductCard key={p.id} product={p} index={i} />)}
  </div>
);

export default function Shop() {
  const { collection = "shop" } = useParams();
  const cfg = COLLECTIONS[collection] || COLLECTIONS.shop;

  let body;
  if (cfg.kind === "overview") {
    body = (
      <div className="space-y-16 lg:space-y-24">
        {cfg.subcats.map((sc) => {
          const items = byCategory(sc);
          return (
            <section key={sc} data-testid={`overview-section-${sc}`}>
              <div className="flex items-end justify-between mb-7">
                <h2 className="font-display text-2xl sm:text-3xl font-bold uppercase tracking-tight">{CATEGORY_LABEL[sc]}</h2>
                <Link to={`/${sc}`} className="inline-flex items-center gap-1.5 text-xs font-bold uppercase tracking-widest text-ink hover:text-denim transition-colors">
                  View all <ArrowRight className="w-3.5 h-3.5" />
                </Link>
              </div>
              <Grid products={items.slice(0, 8)} />
            </section>
          );
        })}
      </div>
    );
  } else {
    let items;
    if (cfg.kind === "hero") items = heroStyles();
    else if (cfg.kind === "all") items = PRODUCTS;
    else items = byCategory(cfg.cat);
    body = (
      <>
        <p data-testid="results-count" className="text-sm text-muted-foreground mb-7">{items.length} styles</p>
        <Grid products={items} />
      </>
    );
  }

  return (
    <div data-testid={`collection-${collection}`}>
      <Banner cfg={cfg} />
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12 py-12 lg:py-16">
        {body}
      </div>
    </div>
  );
}
